import { allowedOtpKeys } from "./allowedOtpKeys";

export const hideHeader = () => {
    const headBar = document.querySelector('.head-bar');
    const header = document.querySelector('.header');
    const barContainer = document.querySelector('.bar-cntnr');
    if (headBar) {
        headBar.style.display = 'none';
    }
    if (header) {
        header.style.display = 'none';
    }
    if (barContainer) {
        barContainer.style.display = 'none';
    }
}

export const allowOnlyNumbers = (e) => {
    const keyCode = e.keyCode;
    if(!allowedOtpKeys.includes(keyCode)) {
        e.preventDefault();
    }
}

export const restrictSpecialChars = (e) => {
    const keyCode = e.keyCode || e.which;
    const keyValue = String.fromCharCode(keyCode);
    if (/[!@#$%^&*(),.?":{}|<>]/.test(keyValue)) {
        e.preventDefault();
    }
};